import React from 'react';
import { connect } from 'react-redux';

const FormSelectWithAdd = ({ name = '', value = '', add, onValueChange, options, disabled = false, role, element = undefined, assign = false }) => {
    return (
        <div className="flex-v mt-16">
            {name !== '' &&
                <div>
                    <h4>{name} :</h4>
                </div>
            }
            <div>
                <select style={{width:'80%'}} disabled={disabled} value={value} onChange={e => onValueChange(e.target.value, element)}>
                    {options.map((option, i) => {
                        return <option key={i} value={assign ? i : option}>{option}</option>
                    })}
                </select>
                <button onClick={() => add()} className="button is-success center ml-8"  style={{display: "inline-block"}}>Add</button>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        role: state.auth.role
    }
}

export default connect(mapStateToProps)(FormSelectWithAdd);